module.exports = __webpack_public_path__ + "static/media/pop up web.d8011f9d.png";